import {useEffect, useState} from 'react'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetExamFilterList = (qualificationFilter = false) => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const [dataList, setDataList] = useState([
		{value: 'all', label: '== 모든 상태 ==', idx: 'all'},
	])
	const [page, setPage] = useState(1)
	const [hasMore, setHasMore] = useState(true)

	const [userRole] = useRoleCookie()
	const rolePath = getApiRolePath(userRole)

	useEffect(() => {
		if (qualificationFilter) {
			setPage(1)
			setHasMore(true)
			fetchRequest('GET', `/${rolePath}/exam/all/list?page=1`)
		}
	}, [])

	// Fetch next page
	const loadMore = () => {
		if (!isLoading && hasMore) {
			const nextPage = page + 1
			setPage(nextPage)
			fetchRequest('GET', `/${rolePath}/exam/all/list?page=${nextPage}`)
		}
	}

	useEffect(() => {
		if (qualificationFilter) {
			if (fetchResult?.statusCode === 200) {
				const fetchedList = fetchResult.data.exam_list || []

				const newItems = fetchedList.map((item) => ({
					...item,
					value: item.franchise_idx === null ? -1 : item.franchise_idx,
					label: item.brand_name,
				}))

				setDataList((prevList) => {
					const merged = [...prevList, ...newItems]
					const seen = new Set()
					return merged.filter((item) => {
						const isDuplicate = seen.has(item.idx)
						seen.add(item.idx)
						return !isDuplicate
					})
				})

				if (fetchResult.data.max_page <= page) {
					setHasMore(false)
				}
			} else if (fetchResult) {
				switch (fetchResult?.statusCode) {
					case 400:
						setAlert('데이터를 불러오는데 실패했습니다.')
						break
					case 401:
					case 403:
						setAlert('현재 권한으로 접근할 수 없습니다.')
						break
					default:
						break
				}
			}
		}
	}, [fetchResult])

	return [dataList, isLoading, loadMore, hasMore]
}

export default useGetExamFilterList
